export default __webpack_public_path__ + "static/media/2504272.b37cf521.jpg";